export * from './administrator.model';
export * from './administrator.service';
export * from './administrator-form.service';


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/shared/index.ts